import {React, useEffect, useState} from "react";
import {useNavigate} from 'react-router-dom';
import { Form, Container, Row, Col } from "react-bootstrap";
import InputField from "../InputField/InputField";
import SlectInputField from "../SlectInputField/SlectInputField";
import BrandLogoSlider from "../BrandLogoSlider/BrandLogoSlider";
import { Link } from "react-router-dom";
import RASelect from 'react-select/async';
import './PartnerSignUp.styles.css';
import { Field, Formik } from 'formik';
import * as Yup from 'yup';
import { Flip, Slide, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { userRegistration,commonGet } from '../../services/auth';


const PartnerSignUp = () => {
  const navigate = useNavigate();
  const partnerSignUpData = {
    email: '',
    passWord: '',
    cPassWord: '',
    fName: '',
    lName: '',
    companyName: '',
    designation: '',
    gender: '',
    dob: '',
    address: '',
    city: "SG",
    state: 'SG',
    zipCode: '',
    country: 'SG',
    contactNo: '',
    confirmationBox: false
  }

  const signUpFormSubmitHandler = async (values) => {
    const url = "accounts/register"
    const val = {
      roletype: "Partner",
      email: values.email,
      username: values.email,
      password: values.passWord,
      confirmpassword: values.cPassWord,
      firstname: values.fName,
      lastname: values.lName,
      apname: values.companyName,
      position: values.designation,
      gender: values.gender,
      dob: values.dob,
      addr1: addValue,//values.address,
      addr2: values.address,
      city: cityValue,
      postcode: postValue,//values.postalcode.toString(),
      area: postValue.substring(0, 2),//values.postalcode.toString(),
      state: stateValue,//values.state,
      country: countryValue,
      mobile: values.contactNo.toString(),
      acceptTerms: values.confirmationBox
    }
    await userRegistration(val, url).then(response=>{
      if (response && response.status == 200) {
        toast.success('Registration Successful. Please click on the link sent in the email to verify your account.', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 4000,
          transition: Slide,
        });
        navigate('/login');
      }
      else if (response && response.status == 202) {
        toast.warning('Email Already Registered. Please use another email or check your mail for more details.', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 5000,
          transition: Slide,
        });
      }
      else if(response.message){
        toast.error(response.message, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 5000,
          transition: Slide,
        });
      }
      else {
        toast.error('Something went Wrong!', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
          transition: Flip,
        })
      }
    })
  }
  toast.configure()
  
  const [countries, setCountries] = useState([]);
  const [countryValue, setCountryValue] = useState('Singapore');
  const [allStates, setAllStates] = useState([]);
  const [states, setStates] = useState([]);
  const [stateValue, setStateValue] = useState('Singapore');
  const [cityValue, setCityValue] = useState('Singapore');
  const [allCities, setAllCities] = useState([]);
  const [cities, setCities] = useState([]);
  const [addValue, setAddValue] = useState('');
  const [addValueChange, setAddValueChange] = useState('');
  const [postValue, setPostValue] = useState('');

  const getCountries = async () => {
    var allCountries = await commonGet(null,`https://devb2b.bizpoint-intl.com:3082/api/sysvar/country`,true);
    var dd=[];
    allCountries.data.country.forEach(element => {
        dd.push({ label: element.varname, value:  element.varid})
    });
    setCountries(dd)
  };

  async function handleCountryChange(event){
    var result=allStates.filter(x=>x.paramvalue===event.target.value);
    var dd=[];
    result.forEach(element => {
      dd.push({ label: element.varname, value:  element.varid})
    });
    setStates(dd);
    setCities([]);
    setCountryValue(countries.filter(x=>x.value===event.target.value)[0]?.label);
  }

  async function handleStateChange(event){
    var result=allCities.filter(x=>x.paramvalue===event.target.value);
    var dd=[];
    result.forEach(element => {
      dd.push({ label: element.varname, value:  element.varid})
    });
    setCities(dd);
    setStateValue(states.filter(x=>x.value===event.target.value)[0]?.label);
  }

  async function handleCityChange(event){
    setCityValue(cities.filter(x=>x.value===event.target.value)[0]?.label);
  }

  useEffect( () => {
    async function method(){
      getCountries();
      var dd=[];
      var allCities = await commonGet(null,`https://devb2b.bizpoint-intl.com:3082/api/sysvar/city`,true);
      setAllCities(allCities.data.city);
      allCities.data.city.forEach(element => {
          dd.push({ label: element.varname, value:  element.varid})
      });
      setCities(dd);
      var allStates = await commonGet(null,`https://devb2b.bizpoint-intl.com:3082/api/sysvar/state`,true);
      setAllStates(allStates.data.state);
      dd=[];
      allStates.data.state.forEach(element => {
        dd.push({ label: element.varname, value:  element.varid})
      });
      setStates(dd);        
    }
    method();
  }, [])
  
  function handlePostalChange(event){
    const postalDiv = event.label.split(' ');
    var postCode="00";
    for (let index = 0; index < postalDiv.length; index++) {
      if(Number(postalDiv[index])>0){
        postCode=postalDiv[index];
      }
    }
    // console.log(postCode)
    setPostValue(postCode);
    setAddValue(event.value);
    setAddValueChange(event.value);
  }

  useEffect(async () => {
    if(addValue){
      window.setPostalCode(addValue);
    }
  }, [addValue])
  
  const filterPostalCodes = async (inputValue) => {
    var result = await commonGet(null,`https://developers.onemap.sg/commonapi/search?searchVal=${inputValue}&returnGeom=N&getAddrDetails=Y&pageNum=1`,true);
    var dd=[];
    if(result.data.results && result.data.results.length >0){
      result.data.results.forEach(element => {
        dd.push({ label: element.SEARCHVAL +"\n"+element.ADDRESS, value:  element.ADDRESS})
    });
    }
    return dd.filter((i) =>
      i.label.toLowerCase().includes(inputValue.toLowerCase())
    );
  };
  
  const promiseOptions = (inputValue) =>
    new Promise((resolve) => {
      if(inputValue.length>1){
        setTimeout(() => {
          resolve(filterPostalCodes(inputValue));
        }, 1000);
      }
  });

  return (
    <>
      <section className="main-container col1-layout">
        <Container className="main">
          <div className="account-login">
            <div className="page-title">
              <h2>PARTNER SIGN UP</h2>
            </div>
            <Formik
              initialValues={partnerSignUpData}
              validationSchema={Yup.object().shape({
                email: Yup.string()
                  .email('Email is invalid')
                  .required('Email is required'),
                passWord: Yup.string()
                  .min(6, 'Password is too Short!')
                  .max(15, 'Password is too Long!')
                  .required('Password is required'),
                cPassWord: Yup.string().min(6)
                  .oneOf([Yup.ref('passWord'), null], 'Passwords must match').required('Confirm your password'),
                fName: Yup.string()
                  .min(2).max(15)
                  .required('First name is required'),
                lName: Yup.string()
                  .min(2).max(15)
                  .required('Last name is required'),
                companyName: Yup.string()
                  .required('Company name is required'),
                designation: Yup.string()
                  .required('Designation  is required'),
                gender: Yup.string().required("Gender is required"),
                dob: Yup.date().required('Date of birth is required'),
                address: Yup.string()
                  // .min(15)
                  .max(200)
                  .required('Address is required'),
                city: Yup.string()
                  .required('Please select your city'),
                country: Yup.string().required(()=>{if(countryValue) return false; else return 'Country is required'}),
                state: Yup.string().required("State is required"),
                // zipCode: Yup.number().min(6).required('please enter your zip/postal code'),
                contactNo: Yup.string()
                  .min(8)//.max(8)
                  .required("Please enter your contact number"),
                confirmationBox: Yup.bool().oneOf([true], 'Please accept terms & conditions')
              })}
              validate={(values) => {
                let errors = {};
                // if (!values.addr1) {
                //   errors.addr1 = "Required";
                // }
                if(addValue==''){
                  errors.address1 = "Address 1 is required";
                }
                else if(addValue.length>150){
                  errors.address1 = "Address 1 must be at most 150 characters";
                }
                return errors;
              }}
              onSubmit={(values, { setSubmitting, resetForm }) => {
                if(!postValue){
                  toast.warning('Please enter your zip/postal code !', {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 3000,
                    transition: Flip,
                  });
                  return false;
                }
                signUpFormSubmitHandler(values);
                setSubmitting(false);
                // resetForm()
              }}
            >
              {props => {
                const {
                  values,
                  touched,
                  errors,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                } = props;
                return (
                  <Form onSubmit={handleSubmit}>
                    <fieldset className="col1-set">
                      <div className="col-1 registered-users">
                        <strong>Account Information</strong>
                        <div className="content">
                          <p>
                            Please ensure your details are complete and accurate. Your
                            profile details will be used as your default billing
                            information on checkout process.
                          </p>
                          <hr />
                          <div className="form-list">
                            <Row>
                              <Col sm={6}>
                                <InputField
                                  Labels="Email Address"
                                  Type="email"
                                  Name="email"
                                  value={values.email}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  isInvalid={!!errors.email}
                                  className={(errors.email && touched.email) ? 'is-invalid' : 'form-control'}
                                />
                              </Col>
                            </Row>
                            <Row>
                              <Col sm={6}>
                                <InputField
                                  Labels="Password"
                                  Type="password"
                                  Name="passWord"
                                  value={values.passWord}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  className={'form-control' + (errors.passWord && touched.passWord ? ' is-invalid' : '')}
                                />
                              </Col>
                            </Row>
                            <Row>
                              <Col sm={6}>
                                <InputField
                                  Labels="Confirm Password"
                                  Type="password"
                                  Name="cPassWord"
                                  value={values.cPassWord}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  className={'form-control' + (errors.cPassWord && touched.cPassWord ? ' is-invalid' : '')}
                                />
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </div>
                    </fieldset>
                    <hr />
                    <fieldset className="col1-set">
                      <div className="col-1 registered-users">
                        <strong>ADMINISTRATOR INFORMATION</strong>
                        <div className="content">
                          <br />
                          <div className="form-list">
                            <Row>
                              <Col sm={6}>
                                <InputField
                                  Labels="First Name"
                                  Type="text"
                                  Name="fName"
                                  value={values.fName}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  className={'form-control' + (errors.fName && touched.fName ? ' is-invalid' : '')}
                                />
                              </Col>
                              <Col sm={6}>
                                <InputField
                                  Labels="Last Name"
                                  Type="text"
                                  Name="lName"
                                  value={values.lName}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  className={'form-control' + (errors.lName && touched.lName ? ' is-invalid' : '')}
                                />
                              </Col>
                            </Row>
                            <Row>
                              <Col sm={6}>
                                <InputField
                                  Labels="Company Name "
                                  Type="text"
                                  Name="companyName"
                                  value={values.companyName}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  className={'form-control' + (errors.companyName && touched.companyName ? ' is-invalid' : '')}
                                />
                              </Col>
                              <Col sm={6}>
                                <InputField
                                  Labels="Designation "
                                  Type="text"
                                  Name="designation"
                                  value={values.designation}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  className={'form-control' + (errors.designation && touched.designation ? ' is-invalid' : '')}
                                />
                              </Col>
                            </Row>
                            <Row>
                              <Col sm={6}>
                                <label>Gender</label>
                                <br />
                                <label style={{ paddingRight: "5px" }}>
                                  <input type="radio" name="gender" value="Male"
                                    checked={values.gender === 'Male'}
                                    onChange={handleChange}
                                    onBlur={handleBlur} />
                                  Male
                                </label>
                                <label>
                                  <input type="radio" name="gender" value="Female"
                                    checked={values.gender === 'Female'} onChange={handleChange}
                                    onBlur={handleBlur} />
                                  Female
                                </label>
                                {(errors.gender && touched.gender) ? (<>
                                  <span style={{ color: 'red', paddingLeft: '20px' }}>{" ! "} {errors.gender} </span><br />
                                </>) : ''}
                              </Col>
                              <Col sm={6}>
                                <InputField
                                  Labels="Date of Birth"
                                  Type="date"
                                  Name="dob"
                                  value={values.dob}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  isInvalid={errors.dob}
                                  feedback={errors.dob}
                                  feedbackType="invalid"
                                  className={'form-control' + (errors.dob && touched.dob ? ' is-invalid' : '')}
                                />
                              </Col>
                            </Row>
                            <Row>
                              
                              <Col sm={6}>
                                <InputField
                                  Labels="Contact No."
                                  Type="number"
                                  Name="contactNo"
                                  value={values.contactNo}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  className={'form-control' + (errors.contactNo && touched.contactNo ? ' is-invalid' : '')}
                                />
                              </Col>
                              <Col sm={6}>
                                <div className="custom_select">
                                  <label>Zip / Postal Code</label>
                                  <RASelect
                                    classNamePrefix="lp-copy-sel customPostalCodeSelect "
                                    defaultOptions 
                                    cacheOptions 
                                    onChange={e=>{handlePostalChange(e); handleChange(e.label);}}
                                    onBlur={handleBlur}
                                    loadOptions={promiseOptions}
                                    className={
                                      (errors.zipCode && touched.zipCode
                                        ? " is-invalid"
                                        : "")
                                    }
                                  />
                                </div>
                              </Col>
                              </Row>
                            
                            <Row>
                            
                              <Col sm={6}>
                                <InputField
                                  Labels="Address 1"
                                  Type="text"
                                  Name="address1"
                                  value={addValue}
                                  onChange={e=>{handleChange(e); setAddValue(e.target.value)}}
                                  onBlur={handleBlur}
                                />
                              </Col>
                              <Col sm={6}>
                                <InputField
                                  Labels="Address 2"
                                  Type="text"
                                  Name="address"
                                  value={values.address}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  className={
                                    "form-control" +
                                    (errors.address && touched.address
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                              </Col>
                            </Row>
                            <Row>
                            <Col sm={6}>
                                <div className="custom_select">
                                  <SlectInputField
                                    abels="Country"
                                    Name="country"
                                    placeHolder="Select Your Country"
                                    options={countries}
                                    value={values.country}
                                    onChange={e=>{values.state=""; setStates([]); values.city=""; setCities([]); handleCountryChange(e); handleChange(e); }}
                                    onBlur={handleBlur}
                                    className={
                                      (errors.country && touched.country
                                        ? " is-invalid"
                                        : "")
                                    }
                                  />
                                </div>
                              </Col>
                              <Col sm={6}>
                                <SlectInputField
                                  Labels="State/Province"
                                  Type="text"
                                  Name="state"
                                  placeHolder="Select Your State"
                                  options={states}
                                  value={values.state}
                                  onChange={e=>{handleStateChange(e); handleChange(e);}}
                                  onBlur={handleBlur}
                                  className={
                                    (errors.state && touched.state
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                              </Col>
                              </Row>
                            <Row>
                              <Col sm={6}>
                                <SlectInputField
                                  Name="city"
                                  id="city"
                                  placeHolder="Please Select City"
                                  value={values.city}
                                  options={cities}
                                  onChange={e=>{handleCityChange(e); handleChange(e);}}
                                  onBlur={handleBlur}
                                  Type="text"
                                  Labels="City"
                                  isInvalid={!!errors.city}
                                  className={(errors.city && touched.city) ? 'is-invalid' : ''}
                                />
                              </Col>
                              </Row>
                            <hr />
                            <li>
                              <Field type="checkbox" name="confirmationBox" />
                              {(errors.confirmationBox && touched.confirmationBox) ? (<>
                                <span style={{ color: 'red' }}>{" ! "} {errors.confirmationBox} </span><br />
                              </>) : ''}
                              <label>
                                <span className="button"></span>
                                <strong> SUBSCRIBE TO OUR NEWSLETTER</strong>
                              </label>
                              <br />
                              <p>
                                Be the first to receive exclusive offers and the
                                latest news on our products and services directly in
                                your inbox. You may unsubscribe any time.
                              </p>

                              <label>
                                <strong>
                                  By providing my information, I acknowledge and
                                  accept the terms of Pacific eShop
                                  <Link to="/">Privacy Policy</Link> and
                                  <Link to="/">Terms of Service</Link>
                                </strong>
                              </label>
                              <br />
                            </li>
                          </div>
                          <br />

                          <div className="buttons-set">
                            <button
                              name="send"
                              type="submit"
                              className="button login"
                            >
                              <span>Register</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </fieldset>
                  </Form>
                )
              }}
            </Formik>
          </div>
        </Container>
      </section>

      <BrandLogoSlider />
    </>
  );
};

export default PartnerSignUp;
